export type NotificationLevel = 'info' | 'success' | 'warn' | 'error';

export interface Notification {
  severity: NotificationLevel;
  message: string;
}
